import React from 'react';
import {
    BottomNavigation,
    BottomNavigationAction,
    Paper,
    Box,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { usePermissions } from 'react-admin';

import SearchIcon from '@mui/icons-material/Search';
import PeopleIcon from '@mui/icons-material/People';
import BusinessIcon from '@mui/icons-material/Business';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PhoneIcon from '@mui/icons-material/Phone';
import CleaningServicesIcon from '@mui/icons-material/CleaningServices';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import BuildIcon from '@mui/icons-material/Build';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import DirectionsWalkIcon from '@mui/icons-material/DirectionsWalk';
import ReceiptIcon from '@mui/icons-material/Receipt';
import RequestQuoteIcon from '@mui/icons-material/RequestQuote';
import HistoryIcon from '@mui/icons-material/History';
import EventIcon from '@mui/icons-material/Event';

const BottomTabMenu = () => {
    const location = useLocation();
    const navigate = useNavigate();
    const [value, setValue] = React.useState(location.pathname);
    const { permissions } = usePermissions();

    const handleChange = (event, newValue) => {
        setValue(newValue);
        navigate(newValue);
    };

    return (
        <>
            <Paper
                sx={{
                    position: 'fixed',
                        bottom: 0,
                        left: 0,
                        right: 0,
                        zIndex: 1201,
                }}
                elevation={3}
            >
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <BottomNavigation value={value} onChange={handleChange} showLabels>
                        <BottomNavigationAction label="顧客検索" value="/customers" icon={<SearchIcon />} />
                        {/* <BottomNavigationAction label="顧客一覧(浄化槽清掃)" value="/customers-clean" icon={<PeopleIcon />} />
                        <BottomNavigationAction label="顧客一覧(浄化槽点検)" value="/customers-inspect" icon={<PeopleIcon />} />
                        <BottomNavigationAction label="顧客一覧(浄化槽修理)" value="/customers-construct" icon={<PeopleIcon />} />
                        <BottomNavigationAction label="顧客一覧(ごみ収集委託)" value="/customers-garbage-commit" icon={<PeopleIcon />} />
                        <BottomNavigationAction label="顧客一覧(ごみ収集許可)" value="/customers-garbage-allow" icon={<PeopleIcon />} />
                        <BottomNavigationAction label="顧客一覧(し尿)" value="/customers-waste" icon={<PeopleIcon />} /> */}
                        <BottomNavigationAction label="管理業者一覧" value="/requesters" icon={<BusinessIcon />} />
                        <BottomNavigationAction label="清掃予定表" value="/cleanReserve" icon={<EventIcon />} />
                        <BottomNavigationAction label="ユーザー一覧" value="/users" icon={<AdminPanelSettingsIcon />} />
                        <BottomNavigationAction label="操作ログ" value="/logText" icon={<HistoryIcon />} />
                    </BottomNavigation>
                    {/* <BottomNavigation value={value} onChange={handleChange} showLabels>
                        <BottomNavigationAction label="清掃受付履歴" value="/cleanReceptHistory" icon={<PhoneIcon />} />
                        <BottomNavigationAction label="清掃予定" value="/cleanReserve" icon={<EventIcon />} />
                        <BottomNavigationAction label="清掃履歴" value="/cleanHistory" icon={<CleaningServicesIcon />} />
                        <BottomNavigationAction label="点検履歴" value="/inspectHistory" icon={<FactCheckIcon />} />
                        <BottomNavigationAction label="修理履歴" value="/constructHistory" icon={<BuildIcon />} />
                        <BottomNavigationAction label="問い合わせ履歴" value="/contactHistory" icon={<ContactSupportIcon />} />
                        <BottomNavigationAction label="訪問履歴" value="/visitHistory" icon={<DirectionsWalkIcon />} />
                        <BottomNavigationAction label="請求履歴" value="/invoiceHistory" icon={<ReceiptIcon />} />
                        <BottomNavigationAction label="見積履歴" value="/estimateHistory" icon={<RequestQuoteIcon />} />
                    </BottomNavigation> */}
                </Box>
            </Paper>
            <div style={{paddingBottom:"140px"}}></div>
        </>
    );
};

export default BottomTabMenu;
